var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCommonError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 82,
    viewBox: "0 0 86 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 35542"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 3133"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6659 72.9994C8.56614 72.9994 2 66.5824 2 58.6668C2 50.7511 8.56614 44.3342 16.6659 44.3342C17.0103 44.3342 17.352 44.3458 17.6905 44.3686C17.4553 43.0595 17.3325 41.7113 17.3325 40.3344C17.3325 27.8166 27.4802 17.6689 39.998 17.6689C49.9915 17.6689 58.4744 24.1366 61.4893 33.1145C62.2036 33.0398 62.929 33.0015 63.6634 33.0015C74.8926 33.0015 83.9957 41.9553 83.9957 53.0004C83.9957 63.4936 75.7796 72.151 65.33 72.9848V72.9994H27.6705H16.6659ZM24.6628 72.9994H20.02H24.6628Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6628 72.9994H20.02M16.6659 72.9994C8.56614 72.9994 2 66.5824 2 58.6668C2 50.7511 8.56614 44.3342 16.6659 44.3342C17.0103 44.3342 17.352 44.3458 17.6905 44.3686C17.4553 43.0595 17.3325 41.7113 17.3325 40.3344C17.3325 27.8166 27.4802 17.6689 39.998 17.6689C49.9915 17.6689 58.4744 24.1366 61.4893 33.1145C62.2036 33.0398 62.9289 33.0015 63.6634 33.0015C74.8926 33.0015 83.9957 41.9553 83.9957 53.0004C83.9957 63.4936 75.7796 72.151 65.33 72.9848V72.9994H27.6705H16.6659Z",
    stroke: "#CA0000",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Shape_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.0513 22.564C33.0513 44.0449 52.3972 61.7455 77.3074 64.1353C74.1857 67.9739 69.3648 70.578 63.8727 70.9872V70.9997H19.1391C13.7116 70.9997 4.64453 68.7129 4.64453 58.6992C4.64453 48.6855 11.6936 46.3988 19.1391 46.3988C19.4558 46.3988 19.7698 46.4087 20.081 46.4283C19.8648 45.3048 19.8268 44.1467 19.7519 42.9661C19.2463 34.991 22.7255 24.9401 33.0633 21.6689C33.055 21.9671 33.0513 22.2652 33.0513 22.564ZM40.0535 56.1724C38.0278 56.1724 36.3857 57.7951 36.3857 59.7969C36.3857 61.7986 38.0278 63.4213 40.0535 63.4213C42.0793 63.4213 43.7214 61.7986 43.7214 59.7969C43.7214 57.7951 42.0793 56.1724 40.0535 56.1724Z",
    fill: "#FDF7F7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval",
    d: "M40.311 63.663C42.3359 63.663 43.9775 62.0215 43.9775 59.9966C43.9775 57.9716 42.3359 56.3301 40.311 56.3301C38.2861 56.3301 36.6445 57.9716 36.6445 59.9966C36.6445 62.0215 38.2861 63.663 40.311 63.663Z",
    stroke: "#CA0000",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line",
    d: "M30 52.3335L34.6664 48.6715L30 45.1855",
    stroke: "#CA0000",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_2",
    d: "M50.6445 52.3335L45.9781 48.6715L50.6445 45.1855",
    stroke: "#CA0000",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval_2",
    d: "M46.6536 24.3311C50.9926 25.4794 54.4186 28.8727 55.6133 33.1927",
    stroke: "#F24822",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval_3",
    d: "M60.6444 12.9998C61.7489 12.9998 62.6443 12.1044 62.6443 10.9999C62.6443 9.89538 61.7489 9 60.6444 9C59.5399 9 58.6445 9.89538 58.6445 10.9999C58.6445 12.1044 59.5399 12.9998 60.6444 12.9998Z",
    stroke: "#F24822",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval_4",
    d: "M81.3554 23.6687C82.4599 23.6687 83.3553 22.7734 83.3553 21.6688C83.3553 20.5643 82.4599 19.6689 81.3554 19.6689C80.2509 19.6689 79.3555 20.5643 79.3555 21.6688C79.3555 22.7734 80.2509 23.6687 81.3554 23.6687Z",
    fill: "#F24822"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line-5",
    d: "M65.8633 18.1738L71.4351 23.7457M71.5198 18.1738L65.948 23.7457L71.5198 18.1738Z",
    stroke: "#F24822",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line-4",
    d: "M2.94531 30.0645L6.9451 34.0642M6.9451 30.0645L2.94531 34.0642L6.9451 30.0645Z",
    stroke: "#F24822",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval_5",
    d: "M11.9999 25.6687C13.1044 25.6687 13.9998 24.7734 13.9998 23.6688C13.9998 22.5643 13.1044 21.6689 11.9999 21.6689C10.8954 21.6689 10 22.5643 10 23.6688C10 24.7734 10.8954 25.6687 11.9999 25.6687Z",
    fill: "#F24822"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonError);
export default __webpack_public_path__ + "static/media/common_error.6fa9e975d6bd2524e6168580620b08d7.svg";
export { ForwardRef as ReactComponent };